// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3h7sb","alert":"SettungsInbox_alert__2FX-N"};